import {Fragment, h} from 'preact';
import s from "./cartResume.module.css";
import {cartArrow} from "../../../../assets";
import {Link} from "preact-router/match";
import {useAppContext, useUserContext, useBehavioralContext} from "../../../../contexts";
import {useCartResume} from "./useCartResume";
import FreightBlock from "./FreightBlock";
import EmptyCart from "./EmptyCart";
import CartWarning from "./CartWarning";
import ProductList from "./ProductList";
import PriceBlock from "./PriceBlock";

const Content = props => {
    // Destructured component props
    const {
        handleCartLoader,
        manuallyRemoveOverflow
    } = props;

    // Component logic data
    const componentProps = useCartResume({
        handleCartLoader
    });

    // Destructured component logic data
    const {
        data,
        isReady,
        updateCart,
        handleBudgetCancelAction
    } = componentProps;

    // Flag to check whether user is signed in or not and cart data
    const [{customer, isSignedIn}, {}, {cartData}] = useUserContext();

    // Retrieves the method to close the side cart menu on business attendance link click
    const {handleCart} = useBehavioralContext();

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // The block in which all zip codes with assigned price will be listed in
    const freightBlock =
        parseInt(data.shipping, 10) > 0 ? (
            <FreightBlock data={data} />
        ) : null;

    // Product list
    const products =
        !data?.items ? null : Object.keys(data.items).map(target => {
            return (
                <ProductList
                    key={target}
                    data={data?.items[target]}
                    cartData={cartData}
                    updateCart={updateCart}
                    target={target}
                />
            );
        });

    // The href for the "finalizar compra button"
    const buttonRedirectTarget =
        !isSignedIn ?
            "/entre" :
            (
                // In case the user must complete setting up his address
                customer?.defaultAddress?.isPending ?
                    "/finalizar-cadastro" :
                    "/checkout"
            );

    // All content goes in this variable, already being validated by data existence
    let content = (
        !data.items ||
        Object.values(data.items).every(list => list.length === 0)
    ) ? (
        <EmptyCart />
    ) : (
        <Fragment>
            <div className={`${s.contentRoot} ${highContrast ? "highGrayColor" : ""}`}>
                <div className={`${s.containerMaxHeight}`}>
                    {products}
                    {freightBlock}
                </div>
                <div className="space-y-4 mt-4 pb-[20px] md:pb-[3rem]">
                    <PriceBlock data={data} />
                    <div className={"w-full flex flex-col gap-6"}>
                        <div className="flex flex-col gap-4 md:gap-6">
                            <Link
                                href={buttonRedirectTarget}
                                className={`${s.buyButton} ${highContrast ? "highFormButtonSecond" : ""}`}
                                onClick={() => {
                                    manuallyRemoveOverflow();
                                    handleCart("isOpen", false);
                                }}
                            >
                                {!cartData["nadLock"] ? "Finalizar compra" : "Finalizar orçamento"}
                                <img
                                    src={cartArrow}
                                    alt="White arrow"
                                />
                            </Link>
                            <Link
                                href={"/"}
                                className={`${s.continueBuyingButton} ${highContrast ? "highFormButtonSecond" : ""}`}
                                onClick={() => !cartData["nadLock"] ? handleCart("isOpen", false) : handleBudgetCancelAction()}
                            >
                                <img
                                    src={cartArrow}
                                    alt="White arrow"
                                />
                                {!cartData["nadLock"] ? "Adicionar mais itens" : "Cancelar orçamento"}
                            </Link>
                        </div>
                        <CartWarning handleCart={handleCart} />
                    </div>
                </div>
            </div>
        </Fragment>
    );

    return (
        <Fragment>
            <div className={
                `font-museo h-full w-full flex flex-col justify-between ${highContrast ? "highGrayColor" : ""}`
            }>
                {!isReady ? null : content}
            </div>
        </Fragment>
    )
}

export default Content;
